export const getLanguageWithoutLocale = language => language ? language.split('-').at(0) : '';
const CHINESE_SIMPLIFIED_CODE = 'zh-cn';

/**
 * Checks if a language is supported as a primary/source language in DeepL
 * @param language The language code to check
 * @param sourceLanguages List of supported source languages
 * @returns boolean indicating if the language is supported
 */
export const checkIsPrimaryLanguageSupportedByDeepL = (language, sourceLanguages = []) => {
  const languageWithoutLocale = getLanguageWithoutLocale(language);
  return language === CHINESE_SIMPLIFIED_CODE || sourceLanguages.includes(languageWithoutLocale);
};

/**
 * Checks if a language is supported as a target language in DeepL
 * @param language The language code to check
 * @param targetLanguages List of supported target languages
 * @returns boolean indicating if the language is supported
 */
export const checkIsSelectedLanguageSupportedByDeepL = (language, targetLanguages = []) => {
  if (language === 'zh' || language.startsWith('zh-')) {
    return language === CHINESE_SIMPLIFIED_CODE;
  }
  const languageWithoutLocale = getLanguageWithoutLocale(language);
  const targetLanguagesWithoutLocale = targetLanguages.map(getLanguageWithoutLocale);
  return targetLanguagesWithoutLocale.includes(languageWithoutLocale);
};